import type { FeatureResultState } from '../../preflight/project-features.js';
import type { PreflightScoreBandCode } from '../../preflight/scoring.js';

export const PUBLIC_API_TOKEN_PREFIX = 'nxe_' as const;

/** `POST /public/auth/token` application rate limit (requests per minute). */
export const PUBLIC_API_TOKEN_EXCHANGE_RATE_LIMIT_PER_MINUTE = 30;

/** Successful upload confirm responses use READY. */
export const PUBLIC_API_UPLOAD_CONFIRM_STATUSES = ['READY'] as const;

/** Report lifecycle statuses in Public API scoring job responses. */
export const PUBLIC_API_REPORT_STATUSES = [
  'QUEUED',
  'ANALYZING',
  'COMPLETED',
  'COMPLETED_WITH_ERRORS',
  'FAILED',
] as const;

export type PublicApiReportStatusCode = (typeof PUBLIC_API_REPORT_STATUSES)[number];

/** Per-asset statuses in Public API scoring job responses. */
export const PUBLIC_API_ASSET_STATUSES = ['PENDING', 'SCORED', 'FAILED'] as const;

export type PublicApiAssetStatusCode = (typeof PUBLIC_API_ASSET_STATUSES)[number];

/** Score bands in Public API scoring job responses. */
export const PUBLIC_API_SCORE_BANDS = [
  'STRONG',
  'NEEDS_REVIEW',
  'AT_RISK',
] as const satisfies readonly PreflightScoreBandCode[];

/** Criterion states in Public API scoring job responses. */
export const PUBLIC_API_FEATURE_STATES = [
  'PASS',
  'FAIL',
  'PARTIAL',
  'NOT_WEIGHTED',
  'NOT_APPLICABLE',
  'NOT_ANALYZED',
] as const satisfies readonly FeatureResultState[];
